import {useCountryLang} from "./useCountryLang";
import {useQuery} from '@tanstack/react-query';
import {request} from "../shared/httpInterceptor";

// Module-level Set to store missing keys
const missingMessageKeys = new Set<string>();

// Create a Proxy to track access to missing keys
const createMessagesProxy = (messages: any) => {
  return new Proxy(messages || {}, {
    get(target, prop) {
      if (typeof prop === 'symbol') return Reflect.get(target, prop);

      if (!(prop in target)) {
        missingMessageKeys.add(prop.toString());
        console.warn(`Missing message key: "${prop}"`);
        return `[missing:${prop}]`; // Visual indicator in UI for missing keys
      }
      return target[prop];
    }
  });
};

export const fetchAllMessages = async (countryLang: string | null, host?: string, context?: any, ip?: any) => {
  const requestConfig: any = {
    url: `/${countryLang}/messages/messages.json`,
    method: 'GET',
    host: host,
    ip: ip
  };

  // Only add context and cookies if they exist
  if (context?.req?.cookies) {
    requestConfig.cookies = context.req.cookies;
  }
  if (context) {
    requestConfig.context = context;
  }

  const res = await request(requestConfig);
  return res.data;
}

export const useMessages = () => {
  const countryLang = useCountryLang();

  return useQuery(
    ["all-messages", countryLang],
    () => fetchAllMessages(countryLang),
    {
      enabled: countryLang != null,
      select: (data: any) => ({
        ...data,
        messages: createMessagesProxy(data.messages)
      })
    }
  );
};

// Export function to get all missing keys in case we'd need it somewhere
export const getMissingMessageKeys = () => Array.from(missingMessageKeys);